import { Text, TextButton, Timeline } from '@wix/design-system';
import { Trans } from '@wix/fe-essentials/react';
import { ElementStatus } from '@wix/rules-panel-ui';
import React from 'react';
import { BiCtaNames, generalToolTips } from '../../../../bi/types';
import { useA11yWizardAdapter } from '../../../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../../../hooks/use-bi-logger';
import { useOpenArticleByEditorHost } from '../../../../hooks/use-open-article-by-editor-host';
import { InaccessibleComponentI18nKeys } from './translation-keys';
export const ElementWithoutContent = _ref => {
  let {
    element,
    elementIndex,
    status,
    kbArticleKey,
    handleRescanClick
  } = _ref;
  const biLogger = useBiLogger();
  const {
    editorHost
  } = useA11yWizardAdapter();
  const {
    openSelectedArticle
  } = useOpenArticleByEditorHost();
  const isFollowArticle = !!element.followArticle;
  const i18nKeys = isFollowArticle ? InaccessibleComponentI18nKeys.followArticle : InaccessibleComponentI18nKeys.noAlternative;
  const firstStep = /*#__PURE__*/React.createElement(Text, {
    size: "tiny"
  }, /*#__PURE__*/React.createElement(Trans, {
    components: {
      componentName: /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "bold"
      }),
      learnMore: /*#__PURE__*/React.createElement(TextButton, {
        as: "a",
        size: "tiny",
        skin: "dark",
        target: "_blank",
        underline: "always",
        onClick: () => {
          openSelectedArticle(editorHost, kbArticleKey);
          biLogger.taskElementCtaClick({
            ctaName: BiCtaNames.LearnMore,
            index: elementIndex,
            status: status ? ElementStatus.ManualPassed : ElementStatus.ManualFailed
          });
        }
      }),
      readArticle: /*#__PURE__*/React.createElement(TextButton, {
        as: "a",
        size: "tiny",
        skin: "dark",
        target: "_blank",
        underline: "always",
        weight: "bold",
        onClick: () => {
          openSelectedArticle(editorHost, kbArticleKey);
          biLogger.taskElementCtaClick({
            ctaName: BiCtaNames.ReadArticle,
            index: elementIndex,
            status: status ? ElementStatus.ManualPassed : ElementStatus.ManualFailed
          });
        }
      })
    },
    i18nKey: i18nKeys.firstStep,
    values: {
      label: element.label ?? ''
    }
  }));
  const secondStep = /*#__PURE__*/React.createElement(Text, {
    size: "tiny"
  }, /*#__PURE__*/React.createElement(Trans, {
    components: {
      rescanButton: /*#__PURE__*/React.createElement(TextButton, {
        size: "tiny",
        skin: "dark",
        underline: "always",
        weight: "bold",
        onClick: () => {
          handleRescanClick();
          biLogger.taskElementCtaClick({
            ctaName: generalToolTips.rescanPage,
            index: elementIndex,
            status: status ? ElementStatus.ManualPassed : ElementStatus.ManualFailed
          });
        }
      })
    },
    i18nKey: InaccessibleComponentI18nKeys.rescanStep
  }));
  const items = [{
    label: firstStep
  }, {
    label: secondStep
  }];
  return /*#__PURE__*/React.createElement(Timeline, {
    gap: "20px",
    items: items,
    skin: "dark"
  });
};
//# sourceMappingURL=element-without-content.js.map